package nl.astraeus.wiki.messages

class GetWikiListMessage() : Message(
  MessageType.GET_WIKI_LIST,
  MessageHeader.WIKI_ID,
) {

  constructor(msg: String) : this() {
    message = msg
  }

}